import { AppDispatch } from '../store'
import overviewActionTypes from '../actionTypes/overview.actionTypes'
import {
    OverviewWidgetResponse_FieldGroup,
    OverviewWidgetResponse_IndexComponent,
    PerformancePeriod
} from '../proto/generated/overview-widget'
import { CommunityScreenMetadata } from '../proto/generated/screener'

const dispatchFieldGroup = (dispatch: AppDispatch, fieldGroup: OverviewWidgetResponse_FieldGroup[]) => {
    dispatch({
        type: overviewActionTypes.SET_FIELD_GROUP,
        payload: fieldGroup
    })
}

const dispatchIndexComponents = (dispatch: AppDispatch, indexComponents: OverviewWidgetResponse_IndexComponent[]) => {
    dispatch({
        type: overviewActionTypes.SAVE_INDEX_COMPONENTS,
        payload: indexComponents
    })
}

const dispatchOverviewData = (
    dispatch: AppDispatch,
    securityKey: string,
    fieldGroups: OverviewWidgetResponse_FieldGroup[],
    indexComponents: OverviewWidgetResponse_IndexComponent[],
    performance: PerformancePeriod[],
    communityScreens: CommunityScreenMetadata[]
) => {
    dispatch({
        type: overviewActionTypes.SET_OVERVIEW_DATA,
        payload: { securityKey, fieldGroups, indexComponents, performance, communityScreens }
    })
}

const clearOverview = (dispatch: AppDispatch) => {
    dispatch({ type: overviewActionTypes.CLEAR_OVERVIEW })
}

const overviewActions = {
    dispatchFieldGroup,
    dispatchIndexComponents,
    dispatchOverviewData,
    clearOverview
}

export default overviewActions